import {
    Chart,
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';

Chart.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Tooltip,
    Legend
);

class Stats
{
    static doChart(data, do_failed)
    {
        let datasets = [
            {
                label: 'Ricevuti',
                data: [],
                borderColor: '#a0d0e0',
                tension: 0.4,
            },
            {
                label: 'Inviati',
                data: [],
                borderColor: '#3c8dbc',
                tension: 0.4
            }
        ];

        if (do_failed) {
            datasets.push({
                label: 'Falliti',
                data: [],
                borderColor: '#ff0000',
                tension: 0.4
            });
        }

        const ctx = document.getElementById('sentFaxChart').getContext('2d');
        const sentFaxChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: [],
                datasets: datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: true
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });

        sentFaxChart.data.labels = data.map(item => item.y);
        sentFaxChart.data.datasets[0].data = data.map(item => item.received);
        sentFaxChart.data.datasets[1].data = data.map(item => item.sent);

        if (do_failed) {
            sentFaxChart.data.datasets[2].data = data.map(item => item.failed);
        }

        sentFaxChart.update();
    }

    static init(container)
    {
        let chart = $('#sentFaxChart', container);

        if (chart.length > 0) {
            /*
                Questo viene popolato nella pagina delle statistiche del
                pannello di amministrazione. In questo caso, devono essere
                mostrati anche i dati sui fax falliti
            */
            let data = window.currentData;

            if (data) {
                Stats.doChart(data, true);
            }
            else {
                $.ajax({
                    url: '/stats/0',
                    method: 'GET',
                    data: {
                        format: 'json'
                    },
                    dataType: 'JSON',
                    success: function(data) {
                        Stats.doChart(data, false);
                    }
                });
            }
        }
    }
}

export default Stats;
